(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["klaviyo-mobile-email-focus"] && !Shopify.designMode) return;
  try {
    (function () {
  "use strict";

  var installKey = "__maytrixKlaviyoMobileEmailFocusV3";
  if (window[installKey]) return;
  window[installKey] = true;

  var formId = "WMghmb";
  var formSelector = ".klaviyo-form-" + formId;
  var emailSelector = ".mx-email-wmghmb input[type=email], input.mx-email-wmghmb[type=email]";
  var mobileQuery = window.matchMedia("(max-width: 767px)");
  var visualViewport = window.visualViewport || null;
  var observer = null;
  var timeoutId = null;
  var layoutFrameId = null;
  var focusedEmail = null;
  var focusViewportHeight = 0;
  var keyboardLayout = null;
  var keyboardStyleNames = [
    "min-height",
    "max-height",
    "overflow-y",
    "overscroll-behavior",
    "-webkit-overflow-scrolling",
    "scroll-padding-block",
    "translate",
    "transition"
  ];

  function stopWatching() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (timeoutId) {
      window.clearTimeout(timeoutId);
      timeoutId = null;
    }
  }

  function visibleEmailInput() {
    if (!mobileQuery.matches) return null;

    var form = document.querySelector(formSelector);
    if (!form || form.getClientRects().length === 0) return null;

    var inputs = form.querySelectorAll(emailSelector);
    for (var index = 0; index < inputs.length; index += 1) {
      var input = inputs[index];
      var styles = window.getComputedStyle(input);

      if (
        input.isConnected &&
        !input.disabled &&
        !input.readOnly &&
        input.getClientRects().length > 0 &&
        styles.display !== "none" &&
        styles.visibility !== "hidden" &&
        !input.closest('[aria-hidden="true"]')
      ) {
        return input;
      }
    }

    return null;
  }

  function viewportHeight() {
    return visualViewport ? visualViewport.height : window.innerHeight;
  }

  function targetForm(input) {
    var root = input ? input.closest(formSelector) : document.querySelector(formSelector);
    if (!root) return null;
    if (root.matches("form.klaviyo-form")) return root;
    return root.querySelector("form.klaviyo-form");
  }

  function rememberKeyboardLayout(form) {
    var styles = {};

    keyboardStyleNames.forEach(function (name) {
      styles[name] = {
        value: form.style.getPropertyValue(name),
        priority: form.style.getPropertyPriority(name)
      };
    });

    keyboardLayout = {
      form: form,
      scrollTop: form.scrollTop,
      styles: styles
    };
  }

  function restoreKeyboardLayout() {
    if (layoutFrameId) {
      window.cancelAnimationFrame(layoutFrameId);
      layoutFrameId = null;
    }
    if (!keyboardLayout) return;

    keyboardStyleNames.forEach(function (name) {
      var original = keyboardLayout.styles[name];
      if (original.value) {
        keyboardLayout.form.style.setProperty(name, original.value, original.priority);
      } else {
        keyboardLayout.form.style.removeProperty(name);
      }
    });
    keyboardLayout.form.scrollTop = keyboardLayout.scrollTop;
    keyboardLayout = null;
  }

  function clearKeyboardSession() {
    restoreKeyboardLayout();
    focusedEmail = null;
    focusViewportHeight = 0;
  }

  function visiblePrimaryButton(form) {
    var buttons = form.querySelectorAll("button.mx-primary");

    for (var index = 0; index < buttons.length; index += 1) {
      var button = buttons[index];
      if (
        button.getClientRects().length > 0 &&
        !button.closest('[aria-hidden="true"]')
      ) {
        return button;
      }
    }

    return null;
  }

  function scrollEmailActionsIntoView(form, input) {
    var button = visiblePrimaryButton(form);
    if (!button) {
      input.scrollIntoView({ block: "center", inline: "nearest" });
      return;
    }

    var formRect = form.getBoundingClientRect();
    var inputRect = input.getBoundingClientRect();
    var buttonRect = button.getBoundingClientRect();
    var groupTop = inputRect.top - formRect.top + form.scrollTop;
    var groupBottom = buttonRect.bottom - formRect.top + form.scrollTop;
    var groupHeight = groupBottom - groupTop;
    var inset = Math.max(12, (form.clientHeight - groupHeight) / 2);

    form.scrollTop = Math.max(0, groupTop - inset);
  }

  function syncKeyboardLayout() {
    layoutFrameId = null;

    if (
      !mobileQuery.matches ||
      !focusedEmail ||
      document.activeElement !== focusedEmail ||
      focusViewportHeight - viewportHeight() < Math.max(120, focusViewportHeight * 0.18)
    ) {
      restoreKeyboardLayout();
      return;
    }

    var form = targetForm(focusedEmail);
    if (!form) {
      restoreKeyboardLayout();
      return;
    }

    if (!keyboardLayout || keyboardLayout.form !== form) {
      restoreKeyboardLayout();
      rememberKeyboardLayout(form);
    }

    var availableHeight = Math.max(1, Math.floor(viewportHeight() - 16));
    var verticalShift = visualViewport
      ? visualViewport.offsetTop + (visualViewport.height - window.innerHeight) / 2
      : 0;

    form.style.setProperty("min-height", "0", "important");
    form.style.setProperty("max-height", availableHeight + "px", "important");
    form.style.setProperty("overflow-y", "auto", "important");
    form.style.setProperty("overscroll-behavior", "contain", "important");
    form.style.setProperty("-webkit-overflow-scrolling", "touch", "important");
    form.style.setProperty("scroll-padding-block", "12px", "important");
    form.style.setProperty("translate", "0 " + Math.round(verticalShift) + "px", "important");
    form.style.setProperty("transition", "none", "important");

    layoutFrameId = window.requestAnimationFrame(function () {
      layoutFrameId = null;
      if (keyboardLayout && document.activeElement === focusedEmail) {
        scrollEmailActionsIntoView(form, focusedEmail);
      }
    });
  }

  function scheduleKeyboardLayout() {
    if (layoutFrameId) window.cancelAnimationFrame(layoutFrameId);
    layoutFrameId = window.requestAnimationFrame(syncKeyboardLayout);
  }

  function focusEmailInput() {
    var input = visibleEmailInput();
    if (!input) return false;

    if (document.activeElement !== input) {
      focusedEmail = input;
      focusViewportHeight = viewportHeight();
    }

    try {
      input.focus();
    } catch (error) {
      return false;
    }

    if (
      document.activeElement === input &&
      window.isSecureContext &&
      navigator.virtualKeyboard &&
      typeof navigator.virtualKeyboard.show === "function"
    ) {
      try {
        navigator.virtualKeyboard.show();
      } catch (error) {}
    }

    if (document.activeElement === input) scheduleKeyboardLayout();

    return document.activeElement === input;
  }

  function waitForEmailInput() {
    stopWatching();
    if (focusEmailInput()) return;

    observer = new MutationObserver(function () {
      if (focusEmailInput()) stopWatching();
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    timeoutId = window.setTimeout(stopWatching, 2500);
  }

  function handleFormEvent(event) {
    var detail = event.detail || {};
    var metaData = detail.metaData || {};
    var eventFormId = String(detail.formId || detail.formID || "");
    var stepName = String(
      metaData.$step_name || metaData.stepName || metaData.step_name || ""
    ).trim().toLowerCase();

    if (eventFormId !== formId) return;

    if (detail.type === "close" || detail.type === "submit") {
      stopWatching();
      clearKeyboardSession();
      return;
    }

    if (detail.type === "stepSubmit" && stepName === "quiz") {
      waitForEmailInput();
    }
  }

  function handleFormClick(event) {
    if (!mobileQuery.matches || !(event.target instanceof Element)) return;

    var form = event.target.closest(formSelector);
    var button = event.target.closest("button.mx-quiz-choice");
    if (!form || !button) return;

    waitForEmailInput();
  }

  function handleFocusIn(event) {
    if (
      !mobileQuery.matches ||
      !(event.target instanceof HTMLInputElement) ||
      !event.target.matches(emailSelector) ||
      !event.target.closest(formSelector)
    ) return;

    if (focusedEmail !== event.target) {
      restoreKeyboardLayout();
      focusedEmail = event.target;
      focusViewportHeight = viewportHeight();
    }
    scheduleKeyboardLayout();
  }

  function handleFocusOut(event) {
    if (event.target !== focusedEmail) return;

    window.setTimeout(function () {
      if (document.activeElement !== focusedEmail) clearKeyboardSession();
    }, 0);
  }

  function handleMobileChange(event) {
    if (!event.matches) clearKeyboardSession();
  }

  window.addEventListener("klaviyoForms", handleFormEvent);
  document.addEventListener("click", handleFormClick);
  document.addEventListener("focusin", handleFocusIn);
  document.addEventListener("focusout", handleFocusOut);
  window.addEventListener("resize", scheduleKeyboardLayout);
  mobileQuery.addEventListener("change", handleMobileChange);
  if (visualViewport) {
    visualViewport.addEventListener("resize", scheduleKeyboardLayout);
    visualViewport.addEventListener("scroll", scheduleKeyboardLayout);
  }
}());
  } catch(e) { console.error(e); }
})();

})();
